import JsFunction from './JsFunction';
import ReturnMultipleType from './DataTypes/ReturnMultipleType';

export default class GetByParamsFunction extends JsFunction {
  nextFunction;

  apiCallPromisified = '';

  entityName = '';

  combination = {};

  attributeParam = '';

  valueParam = '';

  comparisonOperatorParam = '';

  logicalOperatorParam = '';

  importModelParameter = [];

  modelNames = [];

  returnType;

  constructor(method, annotations, htmlDom) {
    super(method, annotations);
    this.combination = annotations[0].combinations.filter((combination) =>  combination.annotationName === method.annotationName);
    this.inputHtmlElement = method.inputHtmlElement || '';
    this.apiCallPromisified = method.apiCallPromisified || '';
    this.entityName = method.entityName || '';
    this.importModelParameter = method.importModelParameter || [];
    this.modelNames = method.modelNames || [];
    this.returnType = new ReturnMultipleType(
      htmlDom,
      this.getMapOfEntitiesToAttributes().get(method.entityName),
      this.annotations,
      method.compId
    );
  }

  printImportStatement() {
    return this.apiInstance + this.importStatement + this.importModelParameter;
  }

  readParams() {

    // We are mapping the comparison operator to the one used in MongoDB. 
    // Then we create the filter object to be used in the API call.
    const operatorMapping = {
      'Equal To': 'eq',
      'Not Equal To': 'ne',
      'Greater Than': 'gt',
      'Greater Than Or Equal To': 'gte',
      'Less Than': 'lt',
      'Less Than Or Equal To': 'lte',
    };
    let filterToAdd = `const filter${this.combination[0].annotationName} = //ADDCODE ; `;

    const addLogicalOperator = (index) => {
      filterToAdd = filterToAdd.replace( '//ADDCODE', `{ $${this.combination[0].logicalOperatorParam[index].toLowerCase()}: [ {${this.combination[0].attributeParam[index]}: { $${operatorMapping[this.combination[0].comparisonOperatorParam[index]]}: "${this.combination[0].valueParam[index]}"}}, //ADDCODE] }`);
    };

    const addLastAttribute = (index) => {
      filterToAdd = filterToAdd.replace( '//ADDCODE', `{${this.combination[0].attributeParam[index]}: { $${operatorMapping[this.combination[0].comparisonOperatorParam[index]]}: "${this.combination[0].valueParam[index]}"}}`)
    };

    if(this.combination[0].attributeParam.length === 1) {
      filterToAdd = `const filter${this.combination[0].annotationName} = {${this.combination[0].attributeParam[0]}: { $${operatorMapping[this.combination[0].comparisonOperatorParam[0]]}: "${this.combination[0].valueParam[0]}"}}; `;
    }else {
      this.combination[0].logicalOperatorParam.forEach((logicalOperator, index) => {
      if (index !== this.combination[0].logicalOperatorParam.length - 1) {
        addLogicalOperator(index);
      } else {
        addLastAttribute(index);
      }
    });
    }
    return filterToAdd;
  }


  printFunction() {
    this.functionality += this.readParams();
    const addedAnnotationName = this.apiCallPromisified.replace('filter', `filter${this.combination[0].annotationName}`);

    this.functionality += addedAnnotationName;

    this.functionality = this.functionality.replace(
      this.functionNextTemplate,
      this.returnType.printFunctionality()
    );
    this.printNextFunctionCode();

    this.functionality = this.returnType.clearTemplate(this.functionality);
    super.clearfunctionNextTemplate();
    return this.functionality;
  }

   printNextFunctionCode() {
    if (this.nextFunction)
      this.functionality = this.functionality.replace(
        this.functionNextTemplate,
        this.nextFunction.printFunction() + this.functionNextTemplate
      );
  }

  printEventToChangePage() {
    this.functionality = this.functionality.replace(
      this.returnType.insideForLoopTemplate,
      `${
        this.returnType.elementTemplate.elementArrayName
      }[i].addEventListener('click',() => {${this.nextFunction.printFunction({
        typeId: 'data[data.length -i -1]._id'
      })}} )`
    );
  }
}
